import MapServiceModel          from '@/models/MapServiceModel';
import PlanAnalysisStatusModel  from '@models/map/PlanAnalysisStatusModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import { DxfLayer }             from '@models/map/dxfTypes';
import { DxfSuggestedCategory } from '@models/map/dxfTypes';
import { PlanDecorLayer }       from '@models/map/dxfTypes';
import { PlanCounters }         from '@models/map/dxfTypes';
import { PlanDoubt }            from '@models/map/dxfTypes';
import { PlanGlyphReport }      from '@models/map/dxfTypes';
import { PlanShape }            from '@models/map/dxfTypes';
import { PlanSourceResult }     from '@models/map/dxfTypes';

/**
 * `GET /plan_analyses/{id}` : **le corps d'une analyse**, une fois qu'elle a abouti
 * (`docs/PLAN_ANALYSE_ASYNC.md` §3).
 *
 * L'analyse n'est plus rendue par le POST qui la demande : celui-ci répond 202 avec un reçu
 * ({@link PlanAnalysisModel}), un consumer travaille, et le résultat se lit ici.
 *
 * ⚠️ `result.source.imageDataUri` **n'est pas stocké** : il pèse ~400 ko, et l'écran l'a déjà
 * reçu de `POST /imports/{id}/plan/source` à l'étape précédente. C'est au panneau de conserver
 * l'image qu'il a en main — voir `analysePlan()`.
 */
@model.urnResource('plan_analysis')
@doc.path('/plan_analyses/{?id}')
export default class PlanAnalysisResultModel extends MapServiceModel {
	private declare _tsFilters: {
		'import': id;
		'planAnalysisStatus': id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(PlanAnalysisStatusModel) declare planAnalysisStatus: PlanAnalysisStatusModel;
	@doc.json declare result: PlanAnalysisPayload | null;
	@doc.string declare errorMessage: string | null;
}

/** Ce que porte `result` — l'union des quatre sorties d'antan, moins l'aperçu. */
export type PlanAnalysisPayload = {
	source: Omit<PlanSourceResult, 'imageDataUri'> & { imageDataUri?: string };
	layers: DxfLayer[];
	suggestedMapping: DxfSuggestedCategory[];
	suggestedDecor?: PlanDecorLayer[];
	shapes: PlanShape[];
	glyphs?: PlanGlyphReport | null;
	doubts: PlanDoubt[];
	counters: PlanCounters;
	truncated: number;
};
